import React from "react";

import { ROUTES } from "../../../system/router/routes";
import { AuthCard, AuthLink, AuthLinkRow } from "./auth-kit";
import { AuthLayout } from "./auth-layout";
import * as Styled from "./auth.styled";

export const NeedHelpPage = () => (
  <AuthLayout dimmed>
    <AuthCard title="Need help?" size="compact">
      <Styled.SupportText>
        You may submit a question or complaint by sending an email to{" "}
        <Styled.SupportLink href="mailto:support@legacydataaccess.com">
          support@legacydataaccess.com
        </Styled.SupportLink>
        .
      </Styled.SupportText>

      <AuthLinkRow>
        <AuthLink to={ROUTES.SIGN_IN}>Back to sign in</AuthLink>
      </AuthLinkRow>
    </AuthCard>
  </AuthLayout>
);
